module.exports = __webpack_public_path__ + "static/img/voice5_down.9a3f370d.png";